

























import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class FmItem extends Vue {
  @Prop() indexNum: number;
  flexShrink: string = '';
  flexBasis: string = '';
  flexGrow: string = '';
  order: string = '';
  alignSelf: string = 'auto';
  get operaAttr(): any {
    let styleArr: any = {}
    if (this.flexShrink.length) {
      styleArr['flexShrink'] = this.flexShrink
    }
    if (this.flexBasis.length) {
      styleArr['flexBasis'] = this.flexBasis
    }
    if (this.flexGrow.length) {
      styleArr['flexGrow'] = this.flexGrow
    }
    if (this.order.length) {
      styleArr['order'] = this.order
    }
    if (this.alignSelf.length) {
      styleArr['alignSelf'] = this.alignSelf
    }
    return styleArr
  }
}
